import React from "react";
import { FormFeedback, FormGroup, Input, Label } from "reactstrap";
import { useField } from "formik";
 
const LocationSelectBox = ({ label = '',id='',name='',placeholder='',value='', isRequired = false,className='',options,onChange }) => {
	const [field, meta] = useField(name);
	const handleOnChange = (e) => {
	    onChange(e);
		};
 
	return (
		<>
			<FormGroup className={`input-wrapper ${className}`}>
				<Label htmlFor={id}>
				<span className={isRequired && 'required'}>{label}</span>
				</Label>
				<Input type="select" name="select" id={id} onChange={($event) => {handleOnChange($event);}} className="form-select">
				  { <option value="">{placeholder}</option> }
					{options && options.map((item, index) => {
						return (<option key={index} selected={value === item._id ? true : false} value={item._id}>
							{item.name}  { item.deleted && '(Archived)'} </option>);

					})}
				</Input>
				{meta.touched && meta.error && (
					<FormFeedback className="d-block"> {meta?.error}</FormFeedback>
				)}
					{options.length === 0 &&  (
					<FormFeedback className="d-block"> {'Please add work group first'}</FormFeedback>
				)}
			</FormGroup>
		</>
	);

};
export default LocationSelectBox;